import { EditCardEntryPage } from "../EditCardEntryPage";

export function AddCardEntryPage() {
  return <EditCardEntryPage isAddingNewCardEntry={true} />;
}
